var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStackedBarEsg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 19,
  width: 5,
  height: 19,
  transform: "rotate(90 19 0)",
  fill: "#048119"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 32,
  width: 5,
  height: 12,
  transform: "rotate(90 32 0)",
  fill: "#04BD24"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 9,
  width: 5,
  height: 15,
  transform: "rotate(90 15 9)",
  fill: "#FFBF0D"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 9,
  width: 5,
  height: 12,
  transform: "rotate(90 28 9)",
  fill: "#9FD926"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 18,
  width: 5,
  height: 18,
  transform: "rotate(90 18 18)",
  fill: "#FF8900"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 27,
  width: 5,
  height: 15,
  transform: "rotate(90 15 27)",
  fill: "#FD4F03"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 27,
  width: 5,
  height: 8,
  transform: "rotate(90 24 27)",
  fill: "#D90400"
})));
export { SvgStackedBarEsg as ReactComponent };
export default __webpack_public_path__ + "stacked_bar_esg.b265a9d5f489d8376fe03a717a3522c1.svg";